import styles from './FeatureList.module.scss'

export default function FeatureList({ features }) {
  if (!features || features.length === 0) {
    return null
  }

  return (
    <div className={styles.features}>
      {features.map(({ id, name }) => (
        <span
          className={`btn btn--secondary btn--small ${styles.feature}`}
          key={id}
        >
          {name}
        </span>
      ))}
    </div>
  )
}
